import { create } from 'zustand';

import { PaymentMethod } from '@/features/payment-method-select';

import { ICurrencyAccount } from '@/entities/currency-account';

import { AddMoneyStep } from './types';

//only steps
interface AddMoneyState {
  step: AddMoneyStep;
  amount: number;
  fee: number;
  cardNumber: string;
  cardExpiry: string;
  cardCvv: string;
  account: ICurrencyAccount | null;
  paymentMethod: PaymentMethod;
}
interface AddMoneyActions {
  setStep: (step: AddMoneyStep) => void;
  setAmount: (amount: number) => void;
  setFee: (fee: number) => void;
  setAccount: (account: ICurrencyAccount | null) => void;
  setCardNumber: (cardNumber: string) => void;
  setCardExpiry: (cardExpiry: string) => void;
  setCardCvv: (cardCvv: string) => void;
  setPaymentMethod: (paymentMethod: PaymentMethod) => void;
  resetCardInfo: VoidFunction;
  resetAddData: VoidFunction;
}

export type AddMoneyStore = AddMoneyState & AddMoneyActions;

//TODO: add other methods and proper steps
const initialState: AddMoneyState = {
  step: 'account',
  paymentMethod: 'bank',
  //deprecated
  amount: 0,
  fee: 0,
  account: null,
  cardNumber: '',
  cardExpiry: '',
  cardCvv: '',
};

export const useAddMoney = create<AddMoneyStore>((set) => ({
  ...initialState,
  setStep: (step: AddMoneyStep) => {
    set({ step });
  },
  setPaymentMethod: (paymentMethod: PaymentMethod) => {
    set({ paymentMethod });
  },
  setAccount: (account: ICurrencyAccount | null) => {
    set({ account });
  },
  setAmount: (amount: number) => {
    set({
      amount,
      fee: Number((amount * 0.04).toFixed(2)),
    });
  },
  setFee: (fee: number) => {
    set({ fee });
  },
  setCardNumber: (cardNumber: string) => {
    set({ cardNumber });
  },
  setCardExpiry: (cardExpiry: string) => {
    set({ cardExpiry });
  },
  setCardCvv: (cardCvv: string) => {
    set({ cardCvv });
  },
  resetCardInfo: () => {
    set({
      cardNumber: '',
      cardExpiry: '',
      cardCvv: '',
    });
  },
  resetAddData: () => {
    set(initialState);
  },
}));
